
import {Component, Vue, Watch} from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import SaasService from "@/services/SaasService";
import ActionService from "@/services/lead/ActionService";
import ClassifyService from "@/services/lead/ClassifyService";
import vSelect from "vue-select";
import { dateFilter, truncateFilter } from "@/utils/filters";
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    vSelect,
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  },

  filters: {
    date: dateFilter,
    truncate: truncateFilter
  }
})

export default class AppMessage extends Vue {
  // Variables
  private saasServiceInstance = new SaasService();
  private saasClassifyInstance = new ClassifyService();
  private actionServiceInstance = new ActionService();

  private allowedFeature: any;
  private isLoadingMessages: boolean = false;
  private subDisplay: string = 'message_table';
  private platformActions: any = [];
  private selectedAction: any = null;
  private filteredAction: any = null;
  private getMessageResponse: any;
  private getClassifyResponse: any = {};
  private selectedNewMessageType: string = 'quick';
  private currentMessageId: number = 0;
  private currentMessageStr: string = '';
  private templateName: string = '';
  private isFallback: boolean = false;
  private isGetTemplateMessagesError: boolean = false;
  private messageClassify = false;

  private messageFields = [
    {key: 'id_template', label: 'ID'},
    {key: 'template_name', label: 'Nome'},
    {key: 'date', label: 'Data'},
    {key: 'mensagem', label: 'Mensagem'},
    {key: 'type', label: 'Tipo'},
    {key: 'action', label: 'Ação'},
    {key: 'status_twilio', label: 'Status Twillio'},
    {key: 'category', label: 'Categoria'},
    // {key: 'hsm', label: 'HSM'},
    // {key: 'status', label: 'Status'},
    // {key: 'delete', label: ''},
  ]

  private twilioStatusLabels = {
    received: 'Recebido',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
  }

  // Table message cells info
  private messageObjsArr: any = [];

  // Functions
  private showNewMessageDisplay() {
    this.subDisplay = 'new_message'
  }

  private showEditMessageDisplay(messageId: number, message: string) {
    this.currentMessageId = messageId
    this.currentMessageStr = message
    this.subDisplay = 'edit_message'
  }

    private async verifyVariable(text) {

        if (/\s{2,}/.test(text) || /[ \n]$/.test(text))
            return true

        const regex = /{{(.*?)}}/g;
        const matches = [...text.matchAll(regex)];
        const variables = matches.map(match => match[1]);
        const regexArray = /^[a-z_{}]+$/;
        const regexTwo = /}+|{+/;

        const allElementsAreLowercaseLettersAndUnderscores = variables.every(
            (element) => regexArray.test(element) && !regexTwo.test(element)
        );
        return !allElementsAreLowercaseLettersAndUnderscores;
  }

  private async createNewMessage(messageStr: string, actionId: number | null, isFallback: boolean, templateName: string) {
      if (await this.verifyVariable(messageStr))
        return this.$store.commit("navBarAlert/DANGER_ALERT", `A mensagem não esta no formado adequado !!!`);

    let params: any;
    if (this.selectedNewMessageType === 'template') {
      params = {
        body: messageStr,
        whatsapp_template: 1,
        default_template: +!isFallback,
        fallback: +isFallback,
        template_name: templateName
      }
    } else if (this.selectedNewMessageType === 'follow-up') {
      params = {
        body: messageStr,
        whatsapp_template: 1,
        default_template: 0,
        fallback: 0,
        template_name: templateName
      }
    } else { // this.selectedNewMessageType === 'quick'
      params = {
        body: messageStr,
        whatsapp_template: 0,
        default_template: 0,
        fallback: 0,
        template_name: templateName
      }
    }

    try {
      const createResponse = await this.saasServiceInstance.createTemplateMessage(this.$auth.user().id_platform, params, actionId)
      this.$store.commit("navBarAlert/SUCCESS_ALERT", "Mensagem criada com sucesso!");
    } catch (e) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao criar mensagem`);
      console.error(e)
    } finally {
      this.subDisplay = 'message_table'
      this.clearVars()
      await this.getMessages()
    }
  }

  private async updateTemplateMessage(templateId: number, messageStr: string) {
    const updateResponse = await this.saasServiceInstance.updateTemplateMessage(templateId, messageStr)
    if (updateResponse.includes('Error')) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao editar mensagem`);
    } else {
      this.$store.commit("navBarAlert/SUCCESS_ALERT", "Mensagem editada com sucesso!");
    }
    this.subDisplay = 'message_table'
    await this.getMessages()
    this.clearVars()
  }

  private async deleteTemplateMessage(templateId: number) {
    const deleteResponse = await this.saasServiceInstance.deleteTemplateMessage(templateId)

    if (deleteResponse.includes('Error')) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao apagar mensagem`);
    } else {
      this.$store.commit("navBarAlert/SUCCESS_ALERT", "Mensagem apagada com sucesso!");
    }
    this.subDisplay = 'message_table'
    await this.getMessages()
    this.clearVars()
  }

  private clearVars() {
    this.subDisplay = 'message_table'
    this.currentMessageId = 0;
    this.currentMessageStr = '';
    this.templateName = '';
    this.selectedAction = null;
    this.selectedNewMessageType = 'quick'
  }

   private async classifyMessage() {
    this.isLoadingMessages = true;
    this.isGetTemplateMessagesError = false;
    this.messageObjsArr = [];

    try {
      this.getClassifyResponse = await this.saasClassifyInstance.classifyMessage(this.currentMessageStr)
        
    } catch (err) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao classificar categoria da mensagem template`);
      this.isGetTemplateMessagesError = true;
      this.isLoadingMessages = false;
      return
    }

    this.isLoadingMessages = false;
  }

  private async getMessages(actionId?: string) {
    this.isLoadingMessages = true;
    this.isGetTemplateMessagesError = false;
    this.getMessageResponse = {};
    this.messageObjsArr = [];

    try {
      this.getMessageResponse = await this.saasServiceInstance.getTemplateMessage(this.$auth.user().id_platform, actionId)
    } catch (err) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao buscar mensagens template`);
      this.isGetTemplateMessagesError = true;
      this.isLoadingMessages = false;
      return
    }

    if (this.getMessageResponse == 'No template found for this platform and action.') {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Nenhuma mensagem encontrada para esta ação`);
      this.messageObjsArr = []
    } else {
      for (const messageObj of Object.values(this.getMessageResponse)) {
        let parsedObj: any = messageObj

        if (parsedObj?.whatsapp_template === 0) {
          parsedObj.type = 'Rápida'
        } else if (parsedObj?.fallback === 1) {
          parsedObj.type = 'Fallback'
        } else if (parsedObj?.default === 0) {
          parsedObj.type = 'Reabertura'
        } else {
          parsedObj.type = 'HSM'
        }

        this.messageObjsArr.push(messageObj)
      }
    }

    if(this.allowedFeature('hsm-message'))
        this.messageFields.push({key: 'hsm', label: 'HSM'});

    if(this.allowedFeature('active-message'))
        this.messageFields.push({key: 'status', label: 'Status'});

    if(this.allowedFeature('delete-message'))
        this.messageFields.push({key: 'delete', label: ''});
        
    this.isLoadingMessages = false;
  }

  private async changeMessageHSM(idAppTemplatesPlatformAction: number, messageState: string) {
    try {
      await this.saasServiceInstance.setTemplateState(idAppTemplatesPlatformAction, messageState)
      this.getMessages()
      return messageState
    } catch(err) {
      console.error(err)
    }
  }

  private async changeMessageStatus(idAppTemplatesPlatformAction: number, messageState: string) {
    try {
      await this.saasServiceInstance.setTemplateStatus(idAppTemplatesPlatformAction, messageState)
      this.getMessages()
      return messageState
    } catch(err) {
      console.error(err)
    }
  }

  private async getActiveActions() {
    try {
      return await this.actionServiceInstance.indexStatus("action_active").then(
        result => {
          this.platformActions = result.body;
          this.platformActions.unshift({label: 'Todas as Ações', id_action: null})
        },
        error => {
          console.error(error)
        }
      );
    } catch (err) {
      console.error(err)
    }
  }

  private getActionLabel(actionsArr, actionId) {
    for (const actionObj of actionsArr) {
      if (actionObj['id_action'] == actionId) {
        return actionObj.label;
      }
    }
  }

  // get states
  private get templateNameState() {
    if (this.templateName === '' || this.templateName === null || this.templateName === undefined) {
      return null
    } else if (!!this.templateName && this.templateName.match(/^[a-z0-9_]*$/)) {
      return true;
    } else {
      return false
    }
  }

  private get currentMessageStrState() {
    if (this.currentMessageStr === '' || this.templateName === null || this.templateName === undefined) {
      return null
    } else if (!!this.currentMessageStr && this.currentMessageStr.length < 1024) {
      return true;
    } else {
      return false
    }
  }

  // Execute upon start
  private created() {
    this.getMessages()
    this.getActiveActions()
  }

}
